module.exports = __webpack_public_path__ + "static/media/gorne-we-2.5069cadb.svg";